import { Button, Link, Notice, Table, Text } from "@smooth/design-system-components"
import NextLink from "next/link"
import { useRouter } from "next/router"
import { useRepayments } from "../hooks/useRepayments"
import Pagination from "src/components/tailwind-components/Pagination"
import { formatDateTime } from "src/features/admin/screen-shared"

const COLUMNS = [
  { key: "id", header: "Id" },
  { key: "reconciliation", header: "Reconciliation" },
  { key: "amount", header: "Amount" },
  { key: "paymentAt", header: "Payment At" },
  { key: "userPaymentAt", header: "ユーザーからの支払日" },
  { key: "userId", header: "ユーザーID" },
  { key: "userName", header: "ユーザー名" },
]

export const RepaymentList = ({ page }: { page: number }) => {
  const router = useRouter()
  const { repayments, pagination, error, isLoading } = useRepayments(page)

  if (error) return <Notice tone="error">一覧を取得できませんでした</Notice>
  if (isLoading) return <Text>読み込み中...</Text>

  const rows = repayments.map((repayment) => ({
    id:
      repayment.id === null ? null : (
        <Link href={`/admin/repayments/${repayment.id}`}>{repayment.id}</Link>
      ),
    reconciliation:
      repayment.reconciliationId === null ? null : (
        <Link href={`/admin/reconciliations/${repayment.reconciliationId}`}>
          {repayment.reconciliationId}
        </Link>
      ),
    amount: repayment.amount,
    paymentAt: formatDateTime(repayment.paymentAt),
    userPaymentAt: formatDateTime(repayment.userPaymentAt),
    userId:
      repayment.userId === null ? null : (
        <Link href={`/admin/users/${repayment.userId}`}>{repayment.userId}</Link>
      ),
    userName: repayment.userName,
  }))

  return (
    <div className="flex flex-col gap-4">
      <div>
        <Button asChild>
          <NextLink href="/admin/repayments/new">新規作成</NextLink>
        </Button>
      </div>
      <Table
        columns={COLUMNS}
        rows={rows}
        onRowClick={(index) => router.push(`/admin/repayments/${repayments[index].id}`)}
      />
      <Pagination
        pagination={{
          currentPage: page,
          totalPages: pagination?.totalPages ?? 1,
          totalCount: pagination?.totalCount ?? 0,
        }}
        onPageChange={(next) => router.push({ query: { ...router.query, page: next } })}
      />
    </div>
  )
}
